import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { WorkflowService } from '../service';
import { SensorWarrantyCheck } from '../model';

@Injectable({
  providedIn: 'root'
})
export class GetSensorWarrantyCheckResolver implements Resolve<SensorWarrantyCheck[]> {

  constructor(private workflowService: WorkflowService) { }

  resolve(): Observable<SensorWarrantyCheck[]> {
    return this.workflowService.getSensorWarrantyCheck();
  }
}
